var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91431 6.30113C5.19045 6.30113 5.41431 6.52499 5.41431 6.80113V11.3746C5.41431 11.6507 5.19045 11.8746 4.91431 11.8746C4.63816 11.8746 4.41431 11.6507 4.41431 11.3746V6.80113C4.41431 6.52499 4.63816 6.30113 4.91431 6.30113Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02539 4.11275C8.30153 4.11275 8.52539 4.3366 8.52539 4.61275V11.3746C8.52539 11.6507 8.30153 11.8746 8.02539 11.8746C7.74925 11.8746 7.52539 11.6507 7.52539 11.3746V4.61275C7.52539 4.3366 7.74925 4.11275 8.02539 4.11275Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0857 8.71788C11.3618 8.71788 11.5857 8.94174 11.5857 9.21788V11.3746C11.5857 11.6507 11.3618 11.8746 11.0857 11.8746C10.8096 11.8746 10.5857 11.6507 10.5857 11.3746V9.21788C10.5857 8.94174 10.8096 8.71788 11.0857 8.71788Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92228 2.03584C2.64004 1.26589 3.66341 0.833328 4.87611 0.833328H11.1237C12.3393 0.833328 13.3629 1.26568 14.0802 2.03608C14.7936 2.80243 15.1666 3.86255 15.1666 5.05677V10.9432C15.1666 12.1374 14.7936 13.1976 14.0802 13.9639C13.3629 14.7343 12.3393 15.1667 11.1237 15.1667H4.87611C3.66056 15.1667 2.63692 14.7343 1.91968 13.9639C1.2062 13.1976 0.833252 12.1374 0.833252 10.9432V5.05677C0.833252 3.86194 1.20815 2.8019 1.92228 2.03584ZM2.65375 2.71772C2.14089 3.26787 1.83325 4.06954 1.83325 5.05677V10.9432C1.83325 11.9311 2.13967 12.7327 2.65158 13.2825C3.15974 13.8283 3.90754 14.1667 4.87611 14.1667H11.1237C12.0923 14.1667 12.8401 13.8283 13.3483 13.2825C13.8602 12.7327 14.1666 11.9311 14.1666 10.9432V5.05677C14.1666 4.06893 13.8602 3.26734 13.3483 2.71748C12.8401 2.17167 12.0923 1.83333 11.1237 1.83333H4.87611C3.91103 1.83333 3.16297 2.17147 2.65375 2.71772Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.dacd2f5f09c885b47f4c065262c9af1e.svg";
export { ForwardRef as ReactComponent };